// @flow
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Select, Spin, Icon, Divider } from "antd";
import api from "../../api";
import _ from "lodash/array";

const Option = Select.Option;

class SelectFetch extends Component {
  static defaultProps = {
    showSearch: false,
    showSubtitle: false,
    showFooter: false,
    disabled: false
  };

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      value: null,
      fetching: false
    };
  }

  componentDidMount = () => {
    if (this.props.selected) {
      this.setState({
        data: [
          {
            value: this.props.selected.id,
            text: this.props.selected.text,
            extra: this.props.selected.extra
          }
        ],
        value: `${this.props.selected.id}`
      });
    }
  };

  componentDidUpdate = prevProps => {
    if (this.props.selected !== prevProps.selected) {
      if (this.props.selected) {
        this.setState({
          data: [
            {
              value: this.props.selected.id,
              text: this.props.selected.text,
              extra: this.props.selected.extra
            }
          ],
          value: `${this.props.selected.id}`
        });
      } else {
        this.setState({
          data: [
            {
              value: null,
              text: null,
              extra: null
            }
          ],
          value: ""
        });
      }
    }
  };

  onFocus = () => {
    this.setState({ data: [], fetching: true });

    api.fetch(`${this.props.url}`).then(response => {
      const data = response.data.map(item => ({
        text: `${item.text}`,
        value: `${item.id}`,
        extra: item.extra
      }));
      this.setState({ data, fetching: false });
    });
  };

  onChange = value => {
    const idx = _.findIndex(this.state.data, ["value", value]);
    if (idx !== -1) {
      this.setState(
        {
          value,
          selected: {
            id: value,
            text: this.state.data[idx].text,
            extra: this.state.data[idx].extra
          },
          fetching: false
        },
        () => {
          return this.props.onChange
            ? this.props.onChange(this.state.selected)
            : null;
        }
      );
    }
  };

  onSearch = value => {
    api
      .fetch(`${this.props.url}&q=${encodeURIComponent(value)}`)
      .then(response => {
        const data = response.data.map(item => ({
          text: `${item.text}`,
          value: `${item.id}`,
          extra: item.extra
        }));
        this.setState({ data, fetching: false });
      });
  };

  renderOptions = (data, showSubtitle) => {
    if (showSubtitle) {
      return data.map(d => (
        <Option key={d.value} title={d.text} style={{ whiteSpace: "normal" }}>
          <div>
            <div>{d.text}</div>
            <div
              style={{
                fontSize: "13px",
                color: "#999",
                textOverflow: "text-overflow"
              }}
            >
              {d.extra ? d.extra.subtext : null}
            </div>
          </div>
        </Option>
      ));
    } else {
      return data.map(d => (
        <Option key={d.value} title={d.text} style={{ whiteSpace: "normal" }}>
          {d.text}
        </Option>
      ));
    }
  };

  render() {
    const { fetching, data, value } = this.state;
    const {
      mode,
      placeholder,
      showSearch,
      showSubtitle,
      showFooter,
      disabled
    } = this.props;
    return (
      <Select
        mode={mode ? mode : "default"}
        disabled={disabled}
        showSearch={showSearch}
        onSearch={this.onSearch}
        value={value}
        placeholder={placeholder ? placeholder : "выберите значение"}
        notFoundContent={fetching ? <Spin size="small" /> : null}
        filterOption={false}
        style={{ width: 120 }}
        onFocus={this.onFocus}
        onChange={this.onChange}
        style={{ width: "100%" }}
        optionLabelProp="title"
        dropdownRender={menu => (
          <div>
            {menu}
            {showFooter ? (
              <React.Fragment>
                <Divider style={{ margin: "4px 0" }} />
                <div
                  style={{ padding: "4px 8px", cursor: "pointer" }}
                  onMouseDown={e => e.preventDefault()}
                  onClick={this.addItem}
                >
                  <Icon type="plus" /> Add item
                </div>
              </React.Fragment>
            ) : null}
          </div>
        )}
      >
        {this.renderOptions(data, showSubtitle)}
      </Select>
    );
  }
}

SelectFetch.propTypes = {
  url: PropTypes.string,
  mode: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.object,
  selected: PropTypes.object,
  onChange: PropTypes.func
};

export default SelectFetch;
